"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CookieDictionary;
(function (CookieDictionary) {
    CookieDictionary["container"] = "#onetrust-consent-sdk #onetrust-banner-sdk";
    CookieDictionary["acceptButton"] = "#onetrust-accept-btn-handler,#accept-recommended-btn-handler";
    CookieDictionary["rejectAllButton"] = "#onetrust-reject-all-handler,.ot-pc-refuse-all-handler";
    CookieDictionary["settingButton"] = "#onetrust-pc-btn-handler";
    CookieDictionary["allowAllButton"] = "#accept-recommended-btn-handler";
    CookieDictionary["confirmSettingButton"] = ".save-preference-btn-handler.onetrust-close-btn-handler";
    CookieDictionary["text"] = "#onetrust-policy-text";
    CookieDictionary["logo"] = ".ot-pc-logo";
    CookieDictionary["footerLogo"] = ".ot-pc-footer-logo";
    CookieDictionary["closeButton"] = "#onetrust-close-btn-container";
    CookieDictionary["bannerTitleColor"] = "#onetrust-policy-title";
    CookieDictionary["cookiePolicyLink"] = "#onetrust-policy-text > a";
})(CookieDictionary = exports.CookieDictionary || (exports.CookieDictionary = {}));
